import axios from '@fs/zion-axios'
import { useCallback, useMemo, useState } from 'react'
import useFetchData from './useFetchData'
import { ContactIdAlreadyInUseError } from '../errors'

const profileUrl = '/service/user/profile/users/CURRENT'
const versionHeader = 'application/familysearch-user-profile+v1.1+json'

const fetchProfile = async () => {
  const { data } = await axios.get(profileUrl, {
    headers: {
      accept: versionHeader,
    },
  })
  return data
}

export default function useProfile() {
  const { data: remoteProfile, loading: profileLoading } = useFetchData(fetchProfile)
  const [localProfile, setLocalProfile] = useState(null)
  const profile = useMemo(() => ({ ...remoteProfile, ...localProfile }), [remoteProfile, localProfile])

  const handleChangeProfile = useCallback(async (newProfile) => {
    try {
      const response = await axios.post(profileUrl, newProfile, {
        headers: { 'Content-Type': 'application/json', accept: versionHeader },
      })
      setLocalProfile({ ...response.data })
    } catch (err) {
      if (err?.response?.data?.message?.includes('contactId is not available')) {
        throw new ContactIdAlreadyInUseError()
      }
      throw err
    }
  }, [])

  return {
    profile,
    profileLoading,
    handleChangeProfile,
  }
}
